import { render, staticRenderFns } from "./FeedbackIconDisplay.vue?vue&type=template&id=85bd2e3c&scoped=true&lang=pug&"
import script from "./FeedbackIconDisplay.vue?vue&type=script&lang=js&"
export * from "./FeedbackIconDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bd2e3c",
  null
  
)

export default component.exports